import { ExtractComponentProp } from '@approvalmax/types';
import { Box } from '@approvalmax/ui/src/components';
import { ApiAmaxPayPaymentDetailsVerificationStatus } from 'shared/data/webApp/v2';

import { messages } from './CheckConfirmationOfPayee.messages';

export const getBackgroundColorByStatus = (
    status?: ApiAmaxPayPaymentDetailsVerificationStatus
): ExtractComponentProp<typeof Box, 'color'> => {
    switch (status) {
        case ApiAmaxPayPaymentDetailsVerificationStatus.full_match:
            return 'mint60';
        case ApiAmaxPayPaymentDetailsVerificationStatus.no_match:
            return 'red30';
        default:
            return 'midnight20';
    }
};

export const getHintText = (reasonCode?: string) => {
    switch (reasonCode) {
        case 'AV100':
            return messages.av100Text;
        case 'AV200':
            return messages.av200Text;
        case 'AV201':
            return messages.av201Text;
        case 'AV202':
        case 'AV203':
        case 'AV204':
        case 'AV205':
        case 'AV207':
            return messages.noMatch;
        case 'AV300':
            return messages.differentBusinessName;
        case 'AV301':
        case 'AV302':
        case 'AV303':
        case 'AV304':
            return messages.differentBusinessType;
        case 'AV305':
            return messages.accountSwitched;
        default:
            return '';
    }
};
